import { IonButton } from '@ionic/react';
import { ChevronUpIcon } from '../theme/Icons';

export interface IChevronButtonProps {
    direction: 'up' | 'down';
    onClick?: () => void;
}

export const ChevronButton: React.FC<IChevronButtonProps> = ({ direction, onClick }) => (
    <IonButton shape="round" style={{margin: -10, padding: 5}} size="small" fill="clear" onClick={onClick}>
        <div style={{rotate: direction === 'up' ? '0deg' : '180deg', transition: 'rotate 0.5s'}}>
            <ChevronUpIcon size="small" />
        </div>
    </IonButton>
);
